import React from 'react'
import Editor from "../editor/Editor"

const Main = () => {
  return (
    <>
      <Editor />
    </>
  )
}

export default Main

